<template>
  <div>
    <van-collapse v-if="list && list.length > 0" v-model="activeName" accordion>
      <van-collapse-item v-for="item in list" :key="item.id" :title="item.name" :name="item.id">
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
        >
          <van-cell v-for="subItem in item.children" clickable @click="getActiveListItem(item.name, subItem.id, subItem.name)" :key="subItem.id" :title="subItem.name">
            <template v-if="subItem.categoryName" #default>
              <span style="color:#ee0a24;">{{subItem.categoryName}}</span>
            </template>
          </van-cell>
        </van-list>
      </van-collapse-item>
    </van-collapse>
    <van-list
        v-else
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
    >
    </van-list>
    <van-popup v-model="pickerVisible" position="bottom" round>
      <van-picker
          :columns="pickerColumns"
          show-toolbar
          :title="itemName + '（' + subItemName + '）'"
          @cancel="onPickerCancel"
          @confirm="onPickerConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import {getCategoryGroupList, updateClerkCategory} from '@/api/clerk/clerk'
import {getCategoryListByGroupId} from '@/api/clerk/category'
import Vue from 'vue';
import { Collapse, Cell, CollapseItem, List, Toast, Dialog, Picker, Popup} from 'vant';
Vue.use(Collapse)
    .use(CollapseItem)
    .use(List)
    .use(Cell)
    .use(Toast)
    .use(Dialog)
    .use(Picker)
    .use(Popup)
    .use(Dialog)
import _ from 'lodash'
export default {
  name: "clerkCategory",
  data() {
    return {
      activeName: '1',
      list: [],
      loading: false,
      finished: false,
      pickerVisible: false,
      itemName: null,
      subItemId: null,
      subItemName: null,
      pickerColumns: [],
      categoryGroupList: []
    };
  },
  methods: {
    loadData(){
      // 直接获取店员所在的一级分类组别以及二级分类组别
      Toast.loading({
        mask: true,
        message: '加载中...'
      })
      getCategoryGroupList().then(res => {
        Toast.clear()
        const data = res.data;
        if (data.code == 0) {
          this.list = data.dataList;
          this.finished = true
        } else {
          Dialog.alert({
            title: '获取店员组别失败',
            message: data.msg
          })
        }
      })
    },
    // 点击列表请求接口数据
    getActiveListItem(itemName, subItemId, subItemName) {
      this.itemName = itemName
      this.subItemId = subItemId
      this.subItemName = subItemName
      Toast.loading({
        mask: true,
        message: '加载中...'
      })
      getCategoryListByGroupId(subItemId).then(res => {
        Toast.clear()
        const data = res.data;
        if (data.code == 0) {
          this.pickerVisible = true
          const dataList = data.dataList
          this.categoryGroupList = dataList
          if (dataList.length > 0) {
            this.pickerColumns = _.map(dataList, (item) => {
              return item.name
            })
          }
        } else {
          Dialog.alert({
            title: '获取店员组别失败',
            message: data.msg
          })
        }
      })
    },
    onPickerConfirm(val) {
      let rank = _.find(this.categoryGroupList, (elem) => {
        return elem.name === val
      })
      this.pickerVisible = false
      Toast.loading({
        mask: true,
        message: '加载中'
      })
      updateClerkCategory(this.subItemId, rank?rank.id:null).then(res => {
        Toast.clear()
        const data = res.data;
        if (data.code == 0) {
          this.loadData()
          Dialog.alert({
            title: '更新我的技能成功'
          })
        } else {
          Dialog.alert({
            title: '获取相关数据失败',
            message: data.msg
          })
        }
      })
    },
    onPickerCancel() {
      this.pickerVisible = false
      this.itemName = null
      this.subItemId = null
      this.subItemName = null
    }
  },
  mounted() {
    this.loadData()
  },
  updated() {
    // 统一替换标签
    this.$replaceLabel(document.body, this.$store.state.label, true)
  }
}
</script>

<style scoped>

</style>
